class CustomerChamberModal {
  constructor(selector) {
    this.form = document.querySelector(selector);
    this.processing = false;

    console.log('form', this.form)

    this.form.addEventListener('submit', (event) => {
      if (this.processing) {
        return;
      }

      event.preventDefault();
      this.submitForm(event);
    });
  }

  async submitForm(event) {
    const formData = Object.fromEntries(new FormData(this.form));
    console.log('formData', formData)

    try {
      this.setProcessing(true);

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('x-authorization-token', this.form.dataset.id);
      headers.append('Authorization', 'Basic ' + this.form.dataset.user);


      const res = await fetch(this.form.getAttribute('action'), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(formData)
      });

      console.log('res', res)

      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`);
      }

      // Force page reload to update server data
      this.setProcessing(false, 'Tiedot päivitetty');
      setTimeout(() => {
        location.reload(true);
      }, 350);
    } catch (err) {
      theme.alert(
        "Tietoja ei voi päivittää juuri nyt. Yritä hetken kuluttua uudestaan.",
        "error",
        7500
      );
      console.error(err);
      this.setProcessing(false);
    }
  }

  /**
   * This function sets the processing state of the form
   * @param {boolean} processing - Whether or not the form is processing
   * @param {string=} str - Optional string to set button text to 
   */
  setProcessing(processing, str) {
    const submitButton = this.form.querySelector('button[type="submit"]');
    this.processing = processing;
    submitButton.classList.toggle('btn--loading')

    if (processing) {
      submitButton.setAttribute('disabled', 'disabled');
    } else {
      submitButton.removeAttribute('disabled');
    }

    if (str) {
      submitButton.textContent = str;
    }
  }
}

new CustomerChamberModal('#customer-modal-form');